module.exports = {
  props: ['items', 'current', 'is-bald'],

  data () {
    return {
      activeItem: 0,
      left: 0
    }
  },

  computed: {
    colors () {
      return this.items.filter((item, index) => index !== 0)
    },

    activeItemIndex () {
      var arr = this.colors.filter(item => item.id === this.current.id)

      return arr.length ? this.colors.indexOf(arr[0]) : -1
    }
  },

  mounted () {
    if (this.colors && this.current) {
      const index = this.colors.findIndex(item => item.id === this.current.id)
      this.clickHandler(index)
    }
  },

  methods: {
    clickHandler (index) {
      if (this.isBald) return

      this.activeItem = index

      if (index === 1 || index === 2) {
        this.left = 0
      } else if (index === this.colors.length - 1 || index === this.colors.length - 2) {
        this.left = -(this.colors.length - 5) * 59
      } else if (index > 2 && index < this.colors.length - 2) {
        this.left = -(index - 2) * 59
      }

      $('.hero-carousel__items').css('left', `${this.left}px`)
      this.$emit('change', this.colors[index])
    },

    prev () {
      if (this.isBald) return

      this.activeItem--

      if (this.activeItem < 0) {
        this.activeItem = this.colors.length - 1
        this.left = -(this.colors.length - 5) * 59
      } else if (this.activeItem === 0 || this.activeItem === 1) {
        this.left = 0
      } else if (this.activeItem > 3) {
        this.left += 59
      }

      $('.hero-carousel__items').css('left', `${this.left}px`)
      this.$emit('change', this.colors[this.activeItem])
    },

    next () {
      if (this.isBald) return

      this.activeItem++

      if (this.activeItem === this.colors.length) {
        this.activeItem = 0
        this.left = 0
      } else if (this.activeItem === this.colors.length -1 || this.activeItem === this.colors.length -2) {
        this.left = -(this.colors.length - 5) * 59
      } else if (this.activeItem > 4) {
        this.left -= 59
      }

      $('.hero-carousel__items').css('left', this.left)
      this.$emit('change', this.colors[this.activeItem])
    }
  },

  template: `
    <div class="d-flex justify-content-center align-items-center">
      <div @click="prev" class="mr-2 mr-md-4 h-pointer"><img src="/static/personal_book_app/img/hero/navigate/l_dark.svg" alt="left"></div>
      <div class="hero-carousel__wrapper">
        <delayed-animation class="hero-carousel__items">
          <div
            @click="clickHandler(index)"
            v-for="(item, index) in colors"
            :key="item.id"
            :style="'background-color:' + item.color"
            class="ml-2 mr-1 h-pointer hero__color hero-carousel__item"
            :class="{ 'hero__color--active': index === activeItemIndex }"
          ></div>
        </delayed-animation>
      </div>
      <div @click="next" class="h-pointer ml-2 ml-md-4"><img src="/static/personal_book_app/img/hero/navigate/r_dark.svg" alt="right"></div>
    </div>
  `
}
